import { getCategories } from '../../model/Product';
import type { Props as ProductCategoryLinksProps } from '../productdetails/ProductCategoryLinks';
import ProductCategoryLinks from '../productdetails/ProductCategoryLinks';
import * as style from './ProductCategories.module.css';

export interface Props extends ProductCategoryLinksProps {
    links?: boolean;
    onlyMainCategory?: boolean;
}

export function ProductCategories({ product, links, onlyMainCategory }: Props) {
    return (
        <p className={style.productCategories} data-track-link-click="product-categories">
            {links ? (
                <ProductCategoryLinks product={product} />
            ) : onlyMainCategory ? (
                (product.main_sub_category?.name ?? product.main_category?.name ?? product.main_category?.code)
            ) : (
                getCategories(product)
            )}
        </p>
    );
}
